export default __webpack_public_path__ + "static/media/actoctt-medium-webfont.960c55f8.woff2";